import { createSlice } from "@reduxjs/toolkit";
const initialState={
  values:{
      username: "",
      password: "",
  },
}

export const loginSlice = createSlice({
  
  name: "login",
  initialState: initialState,
  reducers: {
    login: (state = initialState, action) => {
    
     state.values +=action.payload
    },
  },
});

export const { login} = loginSlice.actions;
export default loginSlice.reducer;
